export default {
  container: {
    padding: 10,
  },
};



// WEBPACK FOOTER //
// ./src/components/Reports/ExceptionsReport/ExceptionDialog/styles.js